import React, { useEffect, useState } from 'react';
import { ACCOUNT_SETTINGS } from './../../Constants/Constants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import DayJsUtil from '@kfc-global/react-shared/utils/DayJSUtils';
import { ButtonComp } from 'atoms/Buttons';
import { MaterialTextInput } from 'atoms/MaterialInput';
import { TooltipView } from 'atoms/Tooltip/index';
import {
  getAndCheck,
  getTernaryValue,
  getCheckIfAnyOnePass,
  getAndCheckIfOneTrue,
  checkAllTrue,
} from 'common/utilities/utils';
import {
  fillDaysList,
  monthList,
  fillYearsList,
  validateName,
  validatePhone,
  validatePostalCode,
  //   validateEmail,
  formatPhoneNumber,
  isValidEditAccountForm,
  dobValidation,
  checkRestrictedWords,
  restrictUserToCharacter,
  formatPostalCode,
} from 'organisms/AccountPage/AU/accountPageUtils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { RESTRICTED_BAD_WORDS } from 'common/constants/restrictionWords';
import {
  RESTRICT_WORDS_REGEX,
  SCROLL_EVENT,
  CLICK_EVENT,
  REMOVE_ONE_OR_MORE_SPACE,
  RESTRICT_SPECIAL_CHARACTERS,
  DATE_FORMATS,
} from 'common/constants/SharedConstants';

const EditPersonalInfo = props => {
  const { isMobile, firstName, lastName, email, phone, postalCode, day, month, year, phonePattern, splitPattern } =
    props;
  const {
    allowOtpPopup,
    maxLengthPhoneNumber,
    dateOfBirth,
    editAccountInfoModal,
    updateCustomerData,
    isEnablePostalCodeSignUp,
    postalCodeRegex,
    phoneNumberRegex,
    postalCodeFormatNumber,
    validateNameRegex, 
    dob
  } = props;

  const [dobInfo, setDobInfo] = useState({
    isValidDOB: true,
    dobErrorMsg: '',
  });
  const [customerInfo, setCustomerInfo] = useState({
    firstName,
    lastName,
    email,
    phone: formatPhoneNumber(phone, phonePattern, splitPattern),
    dateOfBirth,
    postalCode,
    day,
    month,
    year,
    allowOtpPopup: allowOtpPopup
    });
  const [showError, setShowError] = useState(false);

  const [hasFocus, setHasFocus] = useState('');
  const [focusEventId, setFocusEventId] = useState('');
  const [filteredDaysList,] = useState(fillDaysList());
  const {
    PERSONAL_INFO_TEXT,
    SAVE,
    CANCEL,
    FIRST_NAME_ERROR_TEXT,
    FIRST_NAME,
    LAST_NAME,
    LAST_NAME_ERROR_TEXT,
    EMAIL_ADDRESS,
    EMAIL_ERROR_TEXT,
    MOBILE_NUMBER,
    MOBILE_NUMBER_ERROR_TEXT,
    POSTAL_CODE,
    POSTAL_CODE_ERROR_TEXT,
    DATE_OF_BIRTH,
    PHONE_TOOLTIP_TITLE,
    DOB_TOOLTIP_TITLE,
    EVENT_NAME_POSTAL_CODE,
    EVENT_NAME_PHONE,
  } = ACCOUNT_SETTINGS;

  useEffect(() => {
    let checkvalidDOB;
    let checkIfDOBpass = getCheckIfAnyOnePass(customerInfo.day, customerInfo.month, customerInfo.year);
    if (getAndCheck(customerInfo, checkIfDOBpass)) {
      checkvalidDOB = dobValidation(customerInfo.day, customerInfo.month, customerInfo.year);
      setDobInfo({ ...checkvalidDOB });
    } else {
      setDobInfo({
        isValidDOB: true,
        dobErrorMsg: '',
      });
    }
  }, [customerInfo]);

  useEffect(() => {
    window.addEventListener(SCROLL_EVENT, handleClickedOrScroll);
    return () => {
      window.removeEventListener(SCROLL_EVENT, handleClickedOrScroll);
    };
  });

  useEffect(() => {
    window.addEventListener(CLICK_EVENT, handleClickedOrScroll);
    return () => {
      window.removeEventListener(CLICK_EVENT, handleClickedOrScroll);
    };
  });

  const handleClickedOrScroll = event => {
    event.preventDefault();
    setFocusEventId(event.target.id);
    if (event.target.className) {
      if (event.target.className.indexOf('did-floating-select') !== -1) {
        if (!hasFocus || hasFocus === '') {
          setHasFocus(true);
        } else {
          if (event.target.id !== focusEventId) {
            getTernaryValue(hasFocus == true, setHasFocus(false), setHasFocus(true));
          } else {
            setHasFocus(false);
          }
        }
      } else {
        setHasFocus(false);
      }
    }
  };
  const onChangeForm = event => {
    let value = event.target.value;
    if (event.target.name === EVENT_NAME_PHONE) {
      value = event.target.value?.replace(RESTRICT_WORDS_REGEX, '');
    }
    setCustomerInfo({ ...customerInfo, [event.target.name]: value });
  };
  const onBlurFormatPhone = event => {
    const value = formatPhoneNumber(event.target.value, phonePattern, splitPattern);
    setCustomerInfo({ ...customerInfo, phone: value });
  };
  const onFocusFormatPhone = event => {
    let value = event.target.value.replace(RESTRICT_WORDS_REGEX, '');
    setCustomerInfo({ ...customerInfo, phone: value });
  };
  const onChangeOTP = event => {
    if (event.target.name === EVENT_NAME_POSTAL_CODE && event.target.value.length <= 6) {
      const postal = event?.target?.value?.replace(RESTRICT_SPECIAL_CHARACTERS, '');
      setCustomerInfo({ ...customerInfo, [event.target.name]: postal });
      return;
    }
  };
  const onBlurFormatPostCode = event => {
    const value = formatPostalCode(event.target.value, postalCodeFormatNumber);
    setCustomerInfo({ ...customerInfo, postalCode: value });
    setShowError(true);
  };
  const onFocusFormatPostCode = event => {
    const value = event.target.value.replace(REMOVE_ONE_OR_MORE_SPACE, '');
    setCustomerInfo({ ...customerInfo, postalCode: value });
    setShowError(true);
  };
  const renderDateSection = () => {
    return (
      <div>
        <div className='dis-flex'>
          <div className='input-container1'>
            <div className='did-floating-label-content did-error-input'>
              <select
                required
                data-testid='day-testid'
                id='day-list'
                name='day'
                className={`did-floating-select ${getAndCheck(
                  !dobInfo?.isValidDOB && (!dobInfo?.isDaySelected || dobInfo?.isDateNotInRange),
                  'error-color',
                )} ${getAndCheck(dobInfo?.isDayFromLeapYearMonth, 'error-color-disable')} ${getTernaryValue(
                  focusEventId === 'day-list',
                  getTernaryValue(
                    getAndCheckIfOneTrue(!hasFocus, hasFocus === ''),
                    'dropdown-notfocus',
                    'dropdown-focus',
                  ),
                  '',
                )}`}
                value={customerInfo.day}
                onClick={event => {
                  event.preventDefault();
                  window.addEventListener('click', handleClickedOrScroll);
                }}
                onChange={({ target: { value } }) => setCustomerInfo({ ...customerInfo, day: value })}
                // disabled={true  }
                // readOnly={readonly}
              >
                <option value='' key=''></option>
                {filteredDaysList?.map(dayValue => {
                  return (
                    <option value={dayValue} key={dayValue}>
                      {dayValue}
                    </option>
                  );
                })}
              </select>
              <label
                id='date-of-birth-label-text'
                className={`did-floating-label ${getAndCheck(!dobInfo?.isValidDOB, 'error-color')}`}
              >
                 {translateWithI18Next(day)} 
              </label>
            </div>
          </div>
          <div className='input-container2'>
            <div className='did-floating-label-content did-error-input'>
              <select
                required
                data-testid='month-testid'
                id='month-list'
                className={`did-floating-select ${getAndCheck(
                  !dobInfo?.isValidDOB && (!dobInfo?.isMonthSelected || dobInfo?.isDateNotInRange),
                  'error-color',
                )} ${getAndCheck(dobInfo?.isDayFromLeapYearMonth, 'error-color-disable')} ${getTernaryValue(
                  focusEventId === 'month-list',
                  getTernaryValue(
                    getAndCheckIfOneTrue(!hasFocus, hasFocus === ''),
                    'dropdown-notfocus',
                    'dropdown-focus',
                  ),
                  '',
                )}`}
                value={customerInfo.month}
                onClick={event => {
                  event.preventDefault();
                  window.addEventListener('click', handleClickedOrScroll);
                }}
                onChange={({ target: { value } }) => setCustomerInfo({ ...customerInfo, month: value })}
              >
                <option value='' key=''></option>

                {monthList.map(monthValue => {
                  return (
                    <option value={monthValue} key={monthValue}>
                     {translateWithI18Next(monthValue)} 
                    </option>
                  );
                })}
              </select>
              <label
                id='date-of-birth-label-text'
                className={`did-floating-label ${getAndCheck(!dobInfo?.isValidDOB, 'error-color')}`}
              >
                {translateWithI18Next(month)}
              </label>
            </div>
          </div>
          <div className='input-container3'>
            <div className='did-floating-label-content did-error-input'>
              <select
                required
                data-testid='year-testid'
                id='year-list'
                className={`did-floating-select ${getAndCheck(
                  !dobInfo?.isValidDOB && (!dobInfo?.isYearSelected || dobInfo?.isDateNotInRange),
                  'error-color',
                )} ${getAndCheck(dobInfo?.isDayNotValid, 'error-color-disable')} ${getTernaryValue(
                  focusEventId === 'year-list',
                  getTernaryValue(
                    getAndCheckIfOneTrue(!hasFocus, hasFocus === ''),
                    'dropdown-notfocus',
                    'dropdown-focus',
                  ),
                  '',
                )}`}
                value={customerInfo.year}
                onClick={event => {
                  event.preventDefault();
                  window.addEventListener('click', handleClickedOrScroll);
                }}
                onChange={({ target: { value } }) => setCustomerInfo({ ...customerInfo, year: value })}
              >
                <option value='' key=''></option>

                {fillYearsList().map(yearValue => {
                  return (
                    <option value={yearValue} key={yearValue}>
                      {yearValue}
                    </option>
                  );
                })}
              </select>
              <label
                id='date-of-birth-label-text'
                className={`did-floating-label ${getAndCheck(!dobInfo?.isValidDOB, 'error-color')} ${getAndCheck(
                  dobInfo?.isDayNotValid,
                  'error-color-disable',
                )}`}
              >
                {translateWithI18Next(year)}
              </label>
            </div>
          </div>
          {getAndCheck(
            !isMobile,
            <span className='tool-tip-position tool-tip-desktop'>
              <TooltipView placement='top' title={translateWithI18Next(DOB_TOOLTIP_TITLE)}>
                <img class='tooltip-view' src={IMAGE_PATH.Tooltip} alt='tooltip' />
              </TooltipView>
            </span>,
          )}
        </div>
        {getAndCheck(
          !dobInfo?.isValidDOB,
          <div className='dob-error-show flex-div'>
            <div>
              <img src={IMAGE_PATH.Error} alt='Error visible' />
            </div>
            <div>{translateWithI18Next(dobInfo?.dobErrorMsg)}</div>
          </div>,
        )}
      </div>
    );
  };

  return (
    <div className='personal-info-card personal-info-card-au'>
      <div className='personal-card-left-side'>{translateWithI18Next(PERSONAL_INFO_TEXT)}</div>
      <div className='personal-card-right-side'>
        <div className='personal-information-card'>
          <div className='edit-personal-data-view'>
            {getAndCheck(
              !isMobile,
              <div className='left-side-lables'>
                {translateWithI18Next(FIRST_NAME)}
                <span>*</span>
              </div>,
            )}

            <div className='right-side-form'>
              <MaterialTextInput
                data-testid='firstname-testid'
                name={'firstName'}
                placeholder={getTernaryValue(isMobile, `${translateWithI18Next(FIRST_NAME)}*`, '')}
                value={customerInfo?.firstName}
                inputClassName='edit-info-input-class'
                onChange={onChangeForm}
                onKeyPress={restrictUserToCharacter}
                error={getAndCheck(
                  customerInfo?.firstName?.length > 0,
                  getAndCheckIfOneTrue(
                    !validateName(customerInfo?.firstName,validateNameRegex),
                    checkRestrictedWords(RESTRICTED_BAD_WORDS, customerInfo?.firstName),
                  ),
                )}
                helperText={translateWithI18Next(FIRST_NAME_ERROR_TEXT)}
                helperTextClassName='error-text'
                maxLength='100'
                autoComplete='first-name'
                errorIcon={IMAGE_PATH.Error}
                errorIconClassName='flex-div'
              />
            </div>
          </div>

          <div className='edit-personal-data-view'>
            {getAndCheck(
              !isMobile,
              <div className='left-side-lables'>
                {translateWithI18Next(LAST_NAME)}
                <span>*</span>
              </div>,
            )}
            <div className='right-side-form'>
              <MaterialTextInput
                data-testid='lastname-testid'
                name={'lastName'}
                placeholder={getTernaryValue(isMobile, `${translateWithI18Next(LAST_NAME)}*`, '')}
                value={customerInfo?.lastName}
                inputClassName='edit-info-input-class'
                onChange={onChangeForm}
                onKeyPress={restrictUserToCharacter}
                error={getAndCheck(
                  customerInfo?.lastName?.length > 0,
                  getAndCheckIfOneTrue(
                    !validateName(customerInfo?.lastName,validateNameRegex),
                    checkRestrictedWords(RESTRICTED_BAD_WORDS, customerInfo?.lastName),
                  ),
                )}
                helperText={translateWithI18Next(LAST_NAME_ERROR_TEXT)}
                helperTextClassName='error-text'
                maxLength='100'
                autoComplete='last-name'
                errorIcon={IMAGE_PATH.Error}
                errorIconClassName='flex-div'
              />
            </div>
          </div>

          <div className='edit-personal-data-view'>
            {getAndCheck(
              !isMobile,
              <div className='left-side-lables'>
                {translateWithI18Next(EMAIL_ADDRESS)}
                <span>*</span>{' '}
              </div>,
            )}
            <div className='right-side-form email-border'>
              <MaterialTextInput
                data-testid='email-testid'
                name={'email'}
                placeholder={getTernaryValue(isMobile, `${translateWithI18Next(EMAIL_ADDRESS)}*`, '')}
                value={customerInfo?.email}
                inputClassName='edit-info-input-class'
                onChange={onChangeForm}
                // error={customerInfo?.email?.length > 0 && !validateEmail(customerInfo?.email)}
                helperText={translateWithI18Next(EMAIL_ERROR_TEXT)}
                helperTextClassName='error-text'
                maxLength='100'
                autoComplete='off'
                readOnly={true}
                errorIconClassName='flex-div'
              />
            </div>
          </div>
          <div className='edit-personal-data-view'>
            {getAndCheck(
              !isMobile,
              <div className='left-side-lables'>
                {translateWithI18Next(MOBILE_NUMBER)}
                <span>*</span>
              </div>,
            )}
            <div className='right-side-form'>
              <MaterialTextInput
                data-testid='phone-testid'
                name={'phone'}
                placeholder={getTernaryValue(isMobile, `${translateWithI18Next(MOBILE_NUMBER)}*`, '')}
                value={customerInfo?.phone}
                inputClassName='edit-info-input-class'
                onChange={onChangeForm}
                error={getAndCheck(
                  customerInfo?.phone?.length > 0,
                  !validatePhone(customerInfo?.phone, phoneNumberRegex),
                )}
                helperText={translateWithI18Next(MOBILE_NUMBER_ERROR_TEXT)}
                helperTextClassName='error-text'
                autoComplete='mobile-number'
                toolTipText={translateWithI18Next(PHONE_TOOLTIP_TITLE)}
                toolTipSrc={IMAGE_PATH.Tooltip}
                errorIcon={IMAGE_PATH.Error}
                errorIconClassName='flex-div'
                onBlur={onBlurFormatPhone}
                onFocus={onFocusFormatPhone}
                type={'tel'}
                maxLength={maxLengthPhoneNumber}
              />
            </div>
          </div>
          {isEnablePostalCodeSignUp && (
            <div className='edit-personal-data-view'>
              {getAndCheck(
                !isMobile,
                <div className='left-side-lables'>
                  {' '}
                  {translateWithI18Next(POSTAL_CODE)}
                  <span>*</span>
                </div>,
              )}
              <div className='right-side-form'>
                <MaterialTextInput
                  type='text'
                  data-testid='postalcode-testid'
                  name={'postalCode'}
                  placeholder={getTernaryValue(isMobile, `${translateWithI18Next(POSTAL_CODE)}*`, '')}
                  value={customerInfo?.postalCode}
                  inputClassName='edit-info-input-class'
                  onChange={onChangeOTP}
                  error={checkAllTrue([
                    showError,
                    customerInfo?.postalCode?.length > 0,
                    !validatePostalCode(customerInfo?.postalCode, postalCodeRegex),
                  ])}
                  onBlur={onBlurFormatPostCode}
                  onFocus={onFocusFormatPostCode}
                  helperText={translateWithI18Next(POSTAL_CODE_ERROR_TEXT)}
                  helperTextClassName='error-text'
                  autoComplete='postal-code'
                  toolTipSrc={IMAGE_PATH.Tooltip}
                  errorIcon={IMAGE_PATH.Error}
                  errorIconClassName='flex-div'
                />
              </div>
            </div>
          )}
          <div className='edit-personal-data-view'>
            <div className='left-side-lables'>
              {translateWithI18Next(DATE_OF_BIRTH)}
              {getAndCheck(
                isMobile,
                <div>
                  <TooltipView placement='top' title={translateWithI18Next(DOB_TOOLTIP_TITLE)}>
                    <img class='' src={IMAGE_PATH.Tooltip} alt='tooltip' />
                  </TooltipView>
                </div>,
              )}
            </div>
            {getTernaryValue(
              dateOfBirth,
              <div className='dob-present'>
                {dob}
              </div>,
              <div className='right-side-form'>{renderDateSection()}</div>,
            )}
          </div>
          <div className='global-buttons-container'>
            <ButtonComp
              data-testid='edit-account-btn-testid'
              className='buttons-group cancel'
              onClickHandler={() => editAccountInfoModal('fromCancel')}
            >
              {translateWithI18Next(CANCEL)}
            </ButtonComp>
            <ButtonComp
              className={`buttons-group ${getTernaryValue(
                !isValidEditAccountForm({
                  firstNameText: customerInfo.firstName,
                  lastNameText: customerInfo.lastName,
                  phoneNoText: customerInfo.phone,
                  postalCode: customerInfo.postalCode,
                  isValidDOB: dobInfo?.isValidDOB,
                  phoneNumberRegex,
                  postalCodeRegex,
                  isEnablePostalCodeSignUp,
                  postalCodeFormatNumber,
                  validateNameRegex
                }),
                'save-disabled',
                'save',
              )}`}
              disabled={
                !isValidEditAccountForm({
                  firstNameText: customerInfo.firstName,
                  lastNameText: customerInfo.lastName,
                  phoneNoText: customerInfo.phone,
                  postalCode: customerInfo.postalCode,
                  isValidDOB: dobInfo?.isValidDOB,
                  phoneNumberRegex,
                  postalCodeRegex,
                  isEnablePostalCodeSignUp,
                  postalCodeFormatNumber,
                  validateNameRegex
                })
              }
              data-testid='update-account-button-testid-1'
              onClickHandler={() => updateCustomerData(customerInfo)}
            >
              {translateWithI18Next(SAVE)}
            </ButtonComp>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPersonalInfo;
